import {
  BaseQueryFn,
  createApi,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
  FetchBaseQueryMeta,
} from '@reduxjs/toolkit/query/react';

import { encodeURIObject } from '@/lib/utils/object';
import { IMAGES_API_URL } from '@/lib/env';

async function getHeaders() {
  const headers = new Headers({
    'Content-Type': 'application/json',
  });

  return headers;
}

const dynamicBaseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError,
  {} /* eslint-disable-line @typescript-eslint/no-empty-object-type */,
  FetchBaseQueryMeta
> = async (args, api, extraOptions) => {
  return fetchBaseQuery({
    baseUrl: IMAGES_API_URL,
    responseHandler: 'content-type',
    paramsSerializer: encodeURIObject,
    prepareHeaders: () => getHeaders(),
  })(args, api, extraOptions);
};

// initialize an empty api service that we'll inject endpoints into later as needed
export const imagesApi = createApi({
  reducerPath: 'imagesApi',
  // mock Next.js API
  baseQuery: dynamicBaseQuery,
  endpoints: () => ({}),
});
